module.exports = __webpack_public_path__ + "static/media/success-icon.b39bccf9.svg";